export { default } from './Hero'

export { contentMock } from './Hero.mock'

export { HERO_BACKGROUND } from './Hero.const'
